import store from '~/store'

export function parseUrl(config) {
  const storeId = store.getters['auth/activeStore']?.id
  const storeType = store.getters['auth/activeStore']?.store_type

  config.url = config.url?.replace('{storeId}', storeId)

  if (storeType === 'tiktok_global') {
    if (config.url.includes('api/tiktok/')) {
      config.url = config.url.replace('api/tiktok/', 'api/tiktok-global/')
    }
  }

  return config
}